<div class="pb-collapsed__container">
  <div>PLAY</div>
</div>
